export const SURVEY_TYPE_STANDARD = 'standard';
export const SURVEY_TYPE_ABOUT_USER = 'about-users';
export const SURVEY_TYPE_ABOUT_TEACHER = 'about-users-teachers';
export const SURVEY_TYPE_ABOUT_STUDENT = 'about-users-students';
export const SURVEY_TYPE_ABOUT_PARENT = 'about-users-parents';
export const SURVEY_TYPE_ABOUT_CLASSES = 'about-classes';

export const SURVEY_TYPE_ABOUT_USERS = [
    SURVEY_TYPE_ABOUT_USER,
    SURVEY_TYPE_ABOUT_TEACHER
]
